import React, { useState, useEffect, useRef } from "react";

export default function SaveLayerModal({ open, onSave, onCancel }) {
  const [name, setName] = useState("");
  const [isPublic, setIsPublic] = useState(true);
  const inputRef = useRef(null);

  // Clear name on open, focus input
  useEffect(() => {
    if (open) {
      setName("");
      setTimeout(() => { if (inputRef.current) inputRef.current.focus(); }, 100);
    }
  }, [open]);

  if (!open) return null;

  return (
    <div style={{
      position: "fixed",
      zIndex: 1500,
      left: 0, top: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div style={{
        background: "#232439",
        color: "#fff",
        padding: "32px 28px 22px 28px",
        borderRadius: 14,
        boxShadow: "0 8px 30px #000b",
        minWidth: 320,
        maxWidth: "90vw"
      }}>
        <h2 style={{ fontSize: 23, marginBottom: 20 }}>Save New Layer</h2>
        <form
          onSubmit={e => {
            e.preventDefault();
            if (name.trim()) onSave({ name: name.trim(), isPublic });
          }}
          autoComplete="off"
        >
          <label style={{ display: "block", marginBottom: 14 }}>
            Layer Name
            <input
              type="text"
              value={name}
              maxLength={32}
              onChange={e => setName(e.target.value)}
              ref={inputRef}
              style={{
                display: "block",
                width: "100%",
                marginTop: 5,
                padding: "7px 9px",
                borderRadius: 7,
                border: "1px solid #424477",
                background: "#181a29",
                color: "#fff",
                fontSize: 16
              }}
              placeholder="e.g. Town Walls"
            />
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 17, fontSize: 15 }}>
            <input
              type="checkbox"
              checked={isPublic}
              onChange={e => setIsPublic(e.target.checked)}
              style={{ transform: "scale(1.3)" }}
            />
            Public Layer
          </label>
          <div style={{ display: "flex", gap: 14, justifyContent: "flex-end" }}>
            <button type="button" onClick={onCancel} style={{
              background: "#20222a", color: "#ccc", border: "none",
              borderRadius: 7, padding: "7px 20px", fontSize: 15, cursor: "pointer"
            }}>
              Cancel
            </button>
            <button
              type="submit"
              disabled={!name.trim()}
              style={{
                background: "#3643e0", color: "#fff", border: "none",
                borderRadius: 7, padding: "7px 20px", fontSize: 15, fontWeight: 600,
                cursor: !name.trim() ? "not-allowed" : "pointer", opacity: !name.trim() ? 0.5 : 1
              }}
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
